import menuItem from './menu-item';
import user from './user'
import vendorManagement from './vendor-management'
import resource from './resource'

export default {
    namespaced: true,
    modules: {
        menuItem,
        user,
        vendorManagement,
        resource
    }
};
